import { IDocumentEventItem } from '@/document-view/types/document-events-item';
import { EEventName } from '@/document-view/types/enums/event-name';
import { translate } from '@/helpers/translation.helper';

export class AnalyticsHelper {
  static eventTitle(eventItem: IDocumentEventItem): string {
    const name = eventItem.fullName || eventItem.email;
    switch (eventItem.eventName) {
      case EEventName.Sms:
        return translate('was-sent-the-document-by-sms', { name });
      case EEventName.Sent:
        return translate('was-sent-the-document-by-email', { name });
      case EEventName.Reminder:
        return translate('was-sent-a-reminder', { name });
      case EEventName.Video:
        return translate('received-video-message', { name });
      case EEventName.SignedWithoutVerification:
        return `${name} ${translate(eventItem.eventName)}`;
      case EEventName.Delivered:
        return translate('the-document-was-delivered-to', { name });
      case EEventName.Archived:
        return translate('the-document-was-archived');
      case EEventName.HardBouned:
        return translate('the-document-hard-bounced');
      case EEventName.Expired:
        return translate('the-document-expired');
      case EEventName.AttachmentOpened:
        return translate('opened-an-attachment', { name });
      case EEventName.Attachment:
        return translate('opened-an-attachment', { name });
      default:
        return `${name} ${translate(eventItem.eventName).toLowerCase()} ${translate(
          'the-document'
        )}`;
    }
  }

  static getFullName(firstName: string, lastName: string): string {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return firstName || lastName || null;
  }
}
